@import '~style-sheet-helpers/core.less';
@import (reference) '../../../../../../../constants/spacing.module.less';

.popover-content-container {
  max-height: 200px;
}

.stores-list {
  gap: @space-4;
  overflow: hidden auto;
  padding-right: @space-8;
  max-height: 150px;
}
